module.exports = __webpack_public_path__ + "img/CY120007.d946647b.png";